module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_9005.ae9d8bdd.png";